import {ActionMenuContext} from '#/components/actionmenu/action-menu';
import {
  ActionMenuTransactionBorrowAdjust,
  ActionMenuTransactionBorrowClose,
  ActionMenuTransactionBorrowOpen,
  ActionMenuTransactionBuy,
  ActionMenuTransactionClaimRewards,
  ActionMenuTransactionLimitBuy,
  ActionMenuTransactionLimitSell,
  ActionMenuTransactionRent,
  ActionMenuTransactionSell,
  ActionMenuTransactionStopRent,
} from '#/components/actionmenu/sections/transaction/action-menu-transaction-content';
import {ActionMenuSection} from '#/components/actionmenu/types';
import {SLQueryParamConfig, slQueryParamConfigMap} from '#/contexts/query-params-provider';
import {DefaultChildren} from '#/utils/utils';
import qs from 'query-string';
import {FunctionComponent, useContext} from 'react';
import {Navigate} from 'react-router-dom';
import {TransactionType} from 'shareland-common';
import {encodeQueryParams, useQueryParams} from 'use-query-params';

export const ActionMenuTransaction: FunctionComponent<DefaultChildren> = () => {
  const [queryParams] = useQueryParams<SLQueryParamConfig>();

  const {transaction} = useContext(ActionMenuContext);

  // Return
  if (!transaction) {
    const encodedQuery = encodeQueryParams(slQueryParamConfigMap, {
      ...queryParams,
      action: ActionMenuSection.INFORMATION,
    });

    const queryString = `?${qs.stringify(encodedQuery)}`;
    return <Navigate to={`/${queryString}`} replace />;
  }
  switch (transaction.type) {
    case TransactionType.Purchase:
      return <ActionMenuTransactionBuy transactionVars={transaction.data} />;
    case TransactionType.Sell:
      return <ActionMenuTransactionSell transactionVars={transaction.data} />;
    case TransactionType.MintLiquidityToken:
      return <ActionMenuTransactionRent transactionVars={transaction.data} />;
    case TransactionType.BurnLiquidityToken:
      return <ActionMenuTransactionStopRent transactionVars={transaction.data} />;
    case TransactionType.OpenCollateralPosition:
      return <ActionMenuTransactionBorrowOpen transactionVars={transaction.data} />;
    case TransactionType.AdjustCollateralPosition:
      return <ActionMenuTransactionBorrowAdjust transactionVars={transaction.data} />;
    case TransactionType.CloseCollateralPosition:
      return <ActionMenuTransactionBorrowClose transactionVars={transaction.data} />;
    case TransactionType.ClaimRewards:
      return <ActionMenuTransactionClaimRewards transactionVars={transaction.data} />;
    case TransactionType.PurchaseLimitOrder:
      return <ActionMenuTransactionLimitBuy transactionVars={transaction.data} />;
    case TransactionType.SellLimitOrder:
      return <ActionMenuTransactionLimitSell transactionVars={transaction.data} />;
    default:
      return null;
  }
};
